module.exports = __webpack_public_path__ + "static/media/status-in-progress.48d81faa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/status-in-progress.svg
// module id = 225
// module chunks = 0